export default {
  card: {},
  menu: {
    flexDirection: 'column',
    flex: 1,
  },
  navLink: {
    color: 'text',
    mb: 2,
    px: 0,
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      py: '10px',
      cursor: 'pointer',
      borderRadius: '5px',
      border: (t) => `0.5px solid ${t.colors.border_color}`,
      '&:hover': {
        bg: 'button_bg_pressed',
        boxShadow: (t) => `0 2px 4px ${t.colors.shadow}`,
        border: '0.5px solid transparent',
        color: 'text',
      },
    },
    valueText: {
      fontSize: ['12px', '14px', null, '16px'],
      px: '5px',
    },
  },
  grid: {
    gridTemplateColumns: ['repeat(1,1fr)', '1fr 4fr'],
  },
  childrenContainer: {
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
};
